import { render, staticRenderFns } from "./calenSign.vue?vue&type=template&id=388a813f&scoped=true"
import script from "./calenSign.vue?vue&type=script&lang=js"
export * from "./calenSign.vue?vue&type=script&lang=js"
import style0 from "./calenSign.vue?vue&type=style&index=0&id=388a813f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a813f",
  null
  
)

export default component.exports